export default "__VITE_ASSET__cJP6sW8a__"